import { Injectable } from '@angular/core';
import {
  ProcedureImportViewModelPagedModelResponse,
  NonPostService,
  PagedModelRequest,
  ProcedureImportErrorService,
  ProcedureTransactionHoldingService,
  ProcedureTransactionHoldingDetailsViewModel,
  InsuranceProceduresOnHoldService,
  InsuranceProceduresOnHoldViewModelPagedModelResponse,
  FollowUpService,
  DemographicImportErrorService,
  FollowUpViewModelPagedModelResponse,
  DemographicImportErrorDetailsViewModelPagedModelResponse,
  VisitsPendingEligibilityService,
  VisitsPendingEligibilityViewModelPagedModelResponse,
  DeniedChargesService,
  DeniedChargesViewModelPagedModelResponse,
  ClaimStatusService,
  NoResponseVisitsService,
  ClaimStatusViewModelPagedModelResponse,
  NoResponseVisitsViewModelPagedModelResponse,
  OutgoingInsuranceClaimsService,
  OutgoingInsuranceClaimsViewModelPagedModelResponse,
  CollectionsService,
  CreditBalanceService,
  CollectionsViewModelPagedModelResponse,
  CreditBalanceDetailsViewModelPagedModelResponse,
  PatientResponsibleAmountService,
  PatientResponsibleAmountViewModelPagedModelResponse,
  EligibilityErrorService,
  EligibilityErrorViewModelPagedModelResponse,
  EditFollowUpViewModel,
  VisitViewModel,
  BillingService,
  BillVisitViewModel,
  BillingHoldingViewModel,
  PresubmissionErrorService,
  UnappliedRemittanceService,
  UnappliedRemittanceViewModelPagedModelResponse,
  StatementOnHoldService,
  StatementOnHoldViewModelPagedModelResponse,
  UpdateStatementHoldViewModel,
  AddVisitCollectionViewModel,
  AddNoResponseWriteOffViewModel,
  ARTransactionHoldingViewModel,
  UnappliedRemittanceViewModel,
  BatchDetailsViewModel,
  VisitCollection,
  AddAdjustmentViewModel,
  DeniedChargesViewModel,
  PaymentService,
  ImaginePayUnappliedPaymentViewModelPagedModelResponse,
  ImaginePayUnappliedPaymentViewModel,
  StatementService,
  OutgoingStatementViewModelPagedModelResponse,
  QueueService,
  DemographicUpdatesService,
  DemographicUpdatesSummaryViewModelPagedModelResponse,
  DemographicUpdatesDetailViewModel,
  RemoveBillingViewModel,
  VisitService,
  AdjustmentCriteriaViewModel,
  CustomQueueResultsViewModelPagedModelResponse,
  UnderPaymentService,
  UnderPaymentViewModelPagedModelResponse,
  VisitHoldingSimpleViewModel,
  SplitVisitViewModel,
  ImaginePayMessageViewModelPagedModelResponse,
  ImaginePayMessageUpdateModel,
  VisitHoldingViewModel,
  EverywareService,
  EverywareActivityItemViewModelPagedModelResponse,
  VisitHoldingSplitModel
} from 'data';
import { Observable } from 'rxjs';
import { BaseWrapperService } from './base-wrapper.service';
import { PatientResponsibleAccountWriteOffViewModel } from '../../../../../projects/data/src/lib/model/patientResponsibleAccountWriteOffViewModel';
import { SessionStorageService } from '../session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class QueuesWrapperService extends BaseWrapperService {
  constructor(
    private nonPostService: NonPostService,
    private importErrorsService: ProcedureImportErrorService,
    private procedureTransactionHoldingService: ProcedureTransactionHoldingService,
    private insuranceOnHoldProcedureService: InsuranceProceduresOnHoldService,
    private followUpService: FollowUpService,
    private dataCaptureWork: DemographicImportErrorService,
    private visitPendingService: VisitsPendingEligibilityService,
    private deniedChargesService: DeniedChargesService,
    private claimsStatusService: ClaimStatusService,
    private noResponseService: NoResponseVisitsService,
    private outgoingInsuranceClaimService: OutgoingInsuranceClaimsService,
    private collectionsService: CollectionsService,
    private creditBalanceService: CreditBalanceService,
    private patientResponsibleService: PatientResponsibleAmountService,
    private eligibilityErrorService: EligibilityErrorService,
    private billClaimService: BillingService,
    private presubmissionErrorService: PresubmissionErrorService,
    private unappliedPaymentService: UnappliedRemittanceService,
    private statementOnHoldService: StatementOnHoldService,
    private paymentService: PaymentService,
    private statementService: StatementService,
    private queueService: QueueService,
    private demographicUpdateService: DemographicUpdatesService,
    private underpaymentService: UnderPaymentService,
    private visitService: VisitService,
    protected sessionStorageService: SessionStorageService,
    private everywareService: EverywareService
  ) {
    super();
  }

  apiV1UnappliedRemittanceAllPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<UnappliedRemittanceViewModelPagedModelResponse> {
    return this.unappliedPaymentService.apiV1UnappliedRemittanceAllUnappliedPost(
      this.getDataSetId(),
      pagedModelRequest
    );
  }

  apiV1FollowUpAssignToCollectionVisitidPost(visitId: string): Observable<VisitViewModel> {
    return this.followUpService.apiV1FollowUpAssignToCollectionVisitidPost(visitId, this.getDataSetId());
  }

  apiV1FollowUpAssignCollectionMultiplePost(formdata): Observable<any> {
    return this.followUpService.apiV1FollowUpAssignCollectionMultiplePost(this.getDataSetId(), formdata);
  }

  apiV1FollowUpClearFromQueueVisitidPost(visitId: string): Observable<VisitViewModel> {
    return this.followUpService.apiV1FollowUpClearFromQueueVisitidPost(visitId, this.getDataSetId());
  }

  apiV1PresubmissionErrorsGetAllPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<NoResponseVisitsViewModelPagedModelResponse> {
    return this.presubmissionErrorService.apiV1PresubmissionErrorsGetAllPost(this.getDataSetId(), pagedModelRequest);
  }

  apiV1PatientResponsibleAmountWriteoffPost(
    patientWriteOff: PatientResponsibleAccountWriteOffViewModel
  ): Observable<BatchDetailsViewModel> {
    return this.patientResponsibleService.apiV1PatientResponsibleAmountWriteoffPost(
      this.getDataSetId(),
      patientWriteOff
    );
  }

  apiV1PatientResponsibleAmountAssignCollectionsPost(
    visitCollections: AddVisitCollectionViewModel[]
  ): Observable<VisitCollection[]> {
    return this.patientResponsibleService.apiV1PatientResponsibleAmountAssignCollectionsPost(
      this.getDataSetId(),
      visitCollections
    );
  }

  apiV1PatientResponsibleAmountAssignMultipleCollectionsPost(requestBody): Observable<any> {
    return this.patientResponsibleService.apiV1PatientResponsibleAmountAssignMultipleCollectionsPost(
      this.getDataSetId(),
      requestBody
    );
  }

  apiV1BillingHcfaPost(billVisit: BillVisitViewModel[]): Observable<any> {
    return this.billClaimService.apiV1BillingHcfaPost(this.getDataSetId(), billVisit);
  }

  apiV1BillingBillVisitPost(billVisit: BillVisitViewModel): Observable<BillingHoldingViewModel> {
    return this.billClaimService.apiV1BillingBillVisitPost(this.getDataSetId(), billVisit);
  }

  apiV1FollowUpEditPost(
    editFollowUp: EditFollowUpViewModel
  ): Observable<VisitViewModel> {

    return this.followUpService.apiV1FollowUpEditPost(this.getDataSetId(), editFollowUp);
  }

  apiV1FollowUpEditMultiplePost(requestBody): Observable<any> {
    return this.followUpService.apiV1FollowUpEditMultiplePost(this.getDataSetId(), requestBody);
  }

  apiV1FollowUpRebillMultiplePost(requestBody): Observable<any> {
    return this.followUpService.apiV1FollowUpRebillMultiplePost(this.getDataSetId(), requestBody);
  }

  apiV1EligibilityErrorGetAllPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<EligibilityErrorViewModelPagedModelResponse> {
    return this.eligibilityErrorService.apiV1EligibilityErrorGetAllPost(this.getDataSetId(), pagedModelRequest);
  }

  apiV1EligibilityErrorClearIdPost(id: string) {
    return this.eligibilityErrorService.apiV1EligibilityErrorClearIdPost(id, this.getDataSetId());
  }

  apiV1PatientResponsibleAmountAllPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<PatientResponsibleAmountViewModelPagedModelResponse> {
    return this.patientResponsibleService.apiV1PatientResponsibleAmountAllPost(this.getDataSetId(), pagedModelRequest);
  }

  apiV1CreditBalanceAllDetailPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<CreditBalanceDetailsViewModelPagedModelResponse> {
    return this.creditBalanceService.apiV1CreditBalanceAllDetailPost(this.getDataSetId(), pagedModelRequest);
  }

  apiV1CollectionsGetAllPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<CollectionsViewModelPagedModelResponse> {
    return this.collectionsService.apiV1CollectionsGetAllPost(this.getDataSetId(), pagedModelRequest);
  }

  apiV1OutgoingInsuranceClaimsAllPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<OutgoingInsuranceClaimsViewModelPagedModelResponse> {
    return this.outgoingInsuranceClaimService.apiV1OutgoingInsuranceClaimsAllPost(
      this.getDataSetId(),
      pagedModelRequest
    );
  }

  apiV1NoResponseVisitsAssignToFollowupPost(followUp: EditFollowUpViewModel): Observable<VisitViewModel> {
    return this.noResponseService.apiV1NoResponseVisitsAssignToFollowupPost(this.getDataSetId(), followUp);
  }

  apiV1NoResponseVisitsAssignToCollectionPost(
    visitCollection: AddVisitCollectionViewModel
  ): Observable<VisitViewModel> {
    return this.noResponseService.apiV1NoResponseVisitsAssignToCollectionPost(this.getDataSetId(), visitCollection);
  }

  apiV1NoResponseVisitsWriteOffPost(
    writeOff: AddNoResponseWriteOffViewModel
  ): Observable<ARTransactionHoldingViewModel> {
    return this.noResponseService.apiV1NoResponseVisitsWriteOffPost(this.getDataSetId(), writeOff);
  }

  apiV1NoResponseVisitsGetAllPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<NoResponseVisitsViewModelPagedModelResponse> {
    return this.noResponseService.apiV1NoResponseVisitsGetAllPost(this.getDataSetId(), pagedModelRequest);
  }

  apiV1NoResponseVisitsRebillMultiplePost(requestBody): Observable<any> {
    return this.noResponseService.apiV1NoResponseVisitsRebillMultiplePost(this.getDataSetId(), requestBody);
  }

  apiV1NoResponseVisitsAssignMultiplePost(requestBody): Observable<any> {
    return this.noResponseService.apiV1NoResponseVisitsAssignMultiplePost(this.getDataSetId(), requestBody);
  }

  apiV1ClaimStatusGetAllPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<ClaimStatusViewModelPagedModelResponse> {
    return this.claimsStatusService.apiV1ClaimStatusGetAllPost(this.getDataSetId(), pagedModelRequest);
  }

  apiV1ClaimStatusClearIdPost(id: string): Observable<ClaimStatusViewModelPagedModelResponse> {
    return this.claimsStatusService.apiV1ClaimStatusClearIdPost(id, this.getDataSetId());
  }

  apiV1ClaimStatusRebillMultiplePost(requestBody): Observable<any> {
    return this.claimsStatusService.apiV1ClaimStatusRebillMultiplePost(this.getDataSetId(), requestBody);
  }

  apiV1DeniedChargesGetAllPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<DeniedChargesViewModelPagedModelResponse> {
    return this.deniedChargesService.apiV1DeniedChargesGetAllPost(this.getDataSetId(), pagedModelRequest);
  }

  apiV1DeniedChargesClearPost(deniedCharge: DeniedChargesViewModel) {
    return this.deniedChargesService.apiV1DeniedChargesClearPost(this.getDataSetId(), deniedCharge);
  }

  apiV1DeniedChargesRebillMultiplePost(requestBody): Observable<any> {
    return this.deniedChargesService.apiV1DeniedChargesRebillMultiplePost(this.getDataSetId(), requestBody);
  }

  apiV1DeniedChargesClearMultiplePost(requestBody): Observable<any> {
    return this.deniedChargesService.apiV1DeniedChargesClearMultiplePost(this.getDataSetId(), requestBody);
  }

  apiV1VisitsPendingEligibilityClearIdPost(
    id?: string
  ): Observable<VisitsPendingEligibilityViewModelPagedModelResponse> {
    return this.visitPendingService.apiV1VisitsPendingEligibilityClearIdPost(id, this.getDataSetId());
  }

  apiV1VisitsPendingEligibilityAllDetailPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<VisitsPendingEligibilityViewModelPagedModelResponse> {
    return this.visitPendingService.apiV1VisitsPendingEligibilityAllDetailPost(this.getDataSetId(), pagedModelRequest);
  }

  apiV1QueueProcedureHoldQueuenamePost(
    pagedModelRequest: PagedModelRequest,
    queueName: string
  ): Observable<CustomQueueResultsViewModelPagedModelResponse> {
    return this.queueService.apiV1QueueProcedureHoldQueuenamePost(queueName, this.getDataSetId(), pagedModelRequest);
  }

  apiV1QueueProcedureHoldColumnsQueuenamePost(
    pagedModelRequest: PagedModelRequest,
    queueName: string
  ): Observable<CustomQueueResultsViewModelPagedModelResponse> {
    return this.queueService.apiV1QueueProcedureHoldColumnsQueuenamePost(
      queueName,
      this.getDataSetId(),
      pagedModelRequest
    );
  }

  apiV1QueueVisitHoldQueuenamePost(
    pagedModelRequest: PagedModelRequest,
    queueName: string
  ): Observable<CustomQueueResultsViewModelPagedModelResponse> {
    return this.queueService.apiV1QueueVisitHoldQueuenamePost(queueName, this.getDataSetId(), pagedModelRequest);
  }

  apiV1QueueVisitHoldColumnsQueuenamePost(
    pagedModelRequest: PagedModelRequest,
    queueName: string
  ): Observable<CustomQueueResultsViewModelPagedModelResponse> {
    return this.queueService.apiV1QueueVisitHoldColumnsQueuenamePost(queueName, this.getDataSetId(), pagedModelRequest);
  }

  apiV1QueueStatementHoldQueuenamePost(
    pagedModelRequest: PagedModelRequest,
    queueName: string
  ): Observable<CustomQueueResultsViewModelPagedModelResponse> {
    return this.queueService.apiV1QueueStatementHoldQueuenamePost(queueName, this.getDataSetId(), pagedModelRequest);
  }

  apiV1QueueStatementHoldColumnsQueuenamePost(
    pagedModelRequest: PagedModelRequest,
    queueName: string
  ): Observable<CustomQueueResultsViewModelPagedModelResponse> {
    return this.queueService.apiV1QueueStatementHoldColumnsQueuenamePost(
      queueName,
      this.getDataSetId(),
      pagedModelRequest
    );
  }

  apiV1QueueCustomQueueNamesPost(
    pagedModelRequest: PagedModelRequest
  ): Observable<CustomQueueResultsViewModelPagedModelResponse> {
    return this.queueService.apiV1QueueCustomQueueNamesPost(this.getDataSetId(), pagedModelRequest);
  }

  apiV1DemographicImportErrorAllDetailPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<DemographicImportErrorDetailsViewModelPagedModelResponse> {
    return this.dataCaptureWork.apiV1DemographicImportErrorAllDetailPost(this.getDataSetId(), pagedModelRequest);
  }

  apiV1DemographicImportErrorClearIdPost(id: string): Observable<ProcedureImportViewModelPagedModelResponse> {
    return this.dataCaptureWork.apiV1DemographicImportErrorClearIdPost(id, this.getDataSetId());
  }

  apiV1FollowUpGetAllPost(
    pagedModelRequest?: PagedModelRequest,
    patientId?: string
  ): Observable<FollowUpViewModelPagedModelResponse> {
    return this.followUpService.apiV1FollowUpGetAllPost(this.getDataSetId(), patientId, pagedModelRequest);
  }

  apiV1InsuranceProceduresOnHoldGetPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<InsuranceProceduresOnHoldViewModelPagedModelResponse> {
    return this.insuranceOnHoldProcedureService.apiV1InsuranceProceduresOnHoldGetPost(
      this.getDataSetId(),
      pagedModelRequest
    );
  }

  apiV1NonPostPatientPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<ProcedureImportViewModelPagedModelResponse> {
    return this.nonPostService.apiV1NonPostAllDetailPost(this.getDataSetId(), pagedModelRequest);
  }

  apiV1ProcedureImportErrorClearIdPost(id: string): Observable<ProcedureImportViewModelPagedModelResponse> {
    return this.importErrorsService.apiV1ProcedureImportErrorClearIdPost(id, this.getDataSetId());
  }

  apiV1ProcedureTransactionHoldingIdDelete(id: string): Observable<any> {
    return this.procedureTransactionHoldingService.apiV1ProcedureTransactionHoldingIdDelete(id, this.getDataSetId());
  }
  apiV1ProcedureTransactionHoldingDeleteMultiplePost(requestBody): Observable<any> {
    return this.procedureTransactionHoldingService.apiV1ProcedureTransactionHoldingDeleteMultiplePost(
      this.getDataSetId(),
      requestBody
    );
  }

  apiV1ProcedureTransactionHoldingVisitIdDelete(id: string): Observable<any> {
    return this.procedureTransactionHoldingService.apiV1ProcedureTransactionHoldingVisitIdDelete(
      id,
      this.getDataSetId()
    );
  }

  apiV1ProcedureImportErrorAllDetailPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<ProcedureImportViewModelPagedModelResponse> {
    return this.importErrorsService.apiV1ProcedureImportErrorAllDetailPost(this.getDataSetId(), pagedModelRequest);
  }

  apiV1ProcedureTransactionHoldingDetailsIdGet(id: string): Observable<ProcedureTransactionHoldingDetailsViewModel> {
    return this.procedureTransactionHoldingService.apiV1ProcedureTransactionHoldingDetailsIdGet(
      id,
      this.getDataSetId()
    );
  }

  apiV1ProcedureTransactionHoldingVisitDetailsIdGet(
    id: string
  ): Observable<VisitHoldingViewModel> {
    return this.procedureTransactionHoldingService.apiV1ProcedureTransactionHoldingVisitDetailsIdGet(
      id,
      this.getDataSetId()
    );
  }

  apiV1ProcedureTransactionHoldingUpdateTransactionIdPost(
    id: string,
    procedureHolding
  ): Observable<ProcedureTransactionHoldingDetailsViewModel> {
    return this.procedureTransactionHoldingService.apiV1ProcedureTransactionHoldingUpdateTransactionIdPost(
      id,
      this.getDataSetId(),
      procedureHolding
    );
  }

  apiV1ProcedureTransactionHoldingUpdateVisitIdPost(
    id: string,
    visit: VisitHoldingViewModel
  ): Observable<VisitHoldingViewModel> {
    return this.procedureTransactionHoldingService.apiV1ProcedureTransactionHoldingUpdateVisitIdPost(
      id,
      this.getDataSetId(),
      visit
    );
  }

  apiV1ProcedureTransactionHoldingLinkPatientIdIdPost(visitHoldingId: string, patientId: string): Observable<any> {
    return this.procedureTransactionHoldingService.apiV1ProcedureTransactionHoldingLinkPatientIdIdPost(
      visitHoldingId,
      this.getDataSetId(),
      patientId
    );
  }

  apiV1StatementOnHoldGetAllPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<StatementOnHoldViewModelPagedModelResponse> {
    return this.statementOnHoldService.apiV1StatementOnHoldGetAllPost(this.getDataSetId(), pagedModelRequest);
  }

  apiV1StatementOnHoldPatientIdPost(
    id: string,
    updateStatementHoldViewModel?: UpdateStatementHoldViewModel
  ): Observable<any> {
    return this.statementOnHoldService.apiV1StatementOnHoldPatientIdPost(
      id,
      this.getDataSetId(),
      updateStatementHoldViewModel
    );
  }

  apiV1StatementOnHoldUpdateMultiplePost(requestBody): Observable<any> {
    return this.statementOnHoldService.apiV1StatementOnHoldUpdateMultiplePost(this.getDataSetId(), requestBody);
  }

  apiV1UnappliedRemittanceIdDelete(id: string): Observable<any> {
    return this.unappliedPaymentService.apiV1UnappliedRemittanceIdDelete(id, this.getDataSetId());
  }

  apiV1CreditBalanceAdjustPost(adjustment: AddAdjustmentViewModel) {
    return this.creditBalanceService.apiV1CreditBalanceAdjustPost(this.getDataSetId(), adjustment);
  }

  apiV1PaymentImaginepayUnappliedAllPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<ImaginePayUnappliedPaymentViewModelPagedModelResponse> {
    return this.paymentService.apiV1PaymentImaginepayUnappliedAllPost(this.getDataSetId(), pagedModelRequest);
  }

  apiV1PaymentImaginepayUnappliedIdGet(id: string): Observable<ImaginePayUnappliedPaymentViewModel> {
    return this.paymentService.apiV1PaymentImaginepayUnappliedIdGet(id, this.getDataSetId());
  }

  apiV1PaymentImaginepayUnappliedDeleteIdPost(id: string): Observable<any> {
    return this.paymentService.apiV1PaymentImaginepayUnappliedDeleteIdPost(id, this.getDataSetId());
  }

  apiV1StatementOutgoingPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<OutgoingStatementViewModelPagedModelResponse> {
    return this.statementService.apiV1StatementOutgoingPost(this.getDataSetId(), pagedModelRequest);
  }

  apiV1QueueDownloadPost(queue: string, pagedModelRequest?: PagedModelRequest): Observable<any> {
    return this.queueService.apiV1QueueDownloadPost(this.getDataSetId(), queue, pagedModelRequest);
  }
  apiV1QueueDeleteMultipleQueuePost(queue: string, requestBody): Observable<any> {
    return this.queueService.apiV1QueueDeleteMultipleQueuePost(queue, this.getDataSetId(), requestBody);
  }

  apiV1DemographicUpdatesAllPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<DemographicUpdatesSummaryViewModelPagedModelResponse> {
    return this.demographicUpdateService.apiV1DemographicUpdatesAllPost(this.getDataSetId(), pagedModelRequest);
  }

  apiV1DemographicUpdatesDetailsIdPost(id: string): Observable<DemographicUpdatesDetailViewModel> {
    return this.demographicUpdateService.apiV1DemographicUpdatesDetailsIdPost(id, this.getDataSetId());
  }

  apiV1DemographicUpdatesUpdatePost(details: DemographicUpdatesDetailViewModel): Observable<any> {
    return this.demographicUpdateService.apiV1DemographicUpdatesUpdatePost(this.getDataSetId(), details);
  }

  apiV1DemographicUpdatesDeleteIdDelete(id: string): Observable<any> {
    return this.demographicUpdateService.apiV1DemographicUpdatesDeleteIdDelete(id, this.getDataSetId());
  }

  apiV1BillingRemovePost(formdata: RemoveBillingViewModel): Observable<any> {
    return this.billClaimService.apiV1BillingRemovePost(this.getDataSetId(), formdata);
  }

  apiV1BillingRemoveMultiplePost(formdata: RemoveBillingViewModel[]): Observable<any> {
    return this.billClaimService.apiV1BillingRemoveMultiplePost(this.getDataSetId(), formdata);
  }

  apiV1VisitAdjustMultiplePost(formdata: AdjustmentCriteriaViewModel): Observable<any> {
    return this.visitService.apiV1VisitAdjustMultiplePost(this.getDataSetId(), formdata);
  }
  apiV1BillingDropToPaperPost(claimData): Observable<any> {
    return this.billClaimService.apiV1BillingDropToPaperPost(this.getDataSetId(), claimData);
  }

  apiV1UnderpaymentsAllDetailPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<UnderPaymentViewModelPagedModelResponse> {
    return this.underpaymentService.apiV1UnderpaymentsAllDetailPost(this.getDataSetId(), pagedModelRequest);
  }

  apiV1UnderpaymentsClearIdPost(id: string): Observable<any> {
    return this.underpaymentService.apiV1UnderpaymentsClearIdPost(id, this.getDataSetId());
  }

  apiV1ProcedureTransactionHoldingOtherVisitsIdGet(id: string): Observable<VisitHoldingSplitModel> {
    return this.procedureTransactionHoldingService.apiV1ProcedureTransactionHoldingOtherVisitsIdGet(id, this.getDataSetId());
  }
  apiV1ProcedureTransactionHoldingSplitVisitPost(splitModel: SplitVisitViewModel): Observable<any> {
    return this.procedureTransactionHoldingService.apiV1ProcedureTransactionHoldingSplitVisitPost(this.getDataSetId(), splitModel);
  }

  apiV1QueueGetQueuesDataIdPost(id: string, pagedModelRequest?: PagedModelRequest): Observable<any> {
    return this.queueService.apiV1QueueGetQueuesDataIdPost(id, this.getDataSetId(), pagedModelRequest);
  }

  apiV1PaymentAllMessagesPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<ImaginePayMessageViewModelPagedModelResponse> {
    return this.paymentService.apiV1PaymentAllMessagesPost(this.getDataSetId(), pagedModelRequest);
  }

  apiV1PaymentMessagesDeleteIdPost(id: string): Observable<any> {
    return this.paymentService.apiV1PaymentMessagesDeleteIdPost(id, this.getDataSetId());
  }

  apiV1PaymentLinkPatientIdIdPost(messageId: string, patientId: string): Observable<any> {
    return this.paymentService.apiV1PaymentLinkPatientIdIdPost(
      messageId,
      this.getDataSetId(),
      patientId
    );
  }

  apiV1PaymentGetMessageIdPost(id: string): Observable<any> {
    return this.paymentService.apiV1PaymentGetMessageIdPost(id, this.getDataSetId());
  }

  apiV1PaymentMessageUpdatePost(details: ImaginePayMessageUpdateModel): Observable<any> {
    return this.paymentService.apiV1PaymentMessageUpdatePost(this.getDataSetId(), details);
  }

  apiV1EverywareGetAllPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<EverywareActivityItemViewModelPagedModelResponse> {
    return this.everywareService.apiV1EverywareGetAllPost(this.getDataSetId(), pagedModelRequest);
  }

  apiV1EverywareRemoveIdPost(id: string): Observable<any> {
    return this.everywareService.apiV1EverywareRemoveIdPost(id, this.getDataSetId());
  }

  apiV1PaymentAllPaymentErrorsPost(
    pagedModelRequest?: PagedModelRequest
  ): Observable<any> {
    return this.paymentService.apiV1PaymentAllPaymentErrorsPost(this.getDataSetId(), pagedModelRequest);
  }

  apiV1PaymentPaymentErrorClearIdPost(id: string): Observable<any> {
    return this.paymentService.apiV1PaymentPaymentErrorClearIdPost(id, this.getDataSetId());
  }
}
